import { CaseType } from '../enums';

type CaseInput = {
  isComplaintCase: boolean;
  isInsuranceClaimCase: boolean;
  isRepairCase: boolean;
  isSalesCase: boolean;
};

export const sortArrayOfObjects = <T extends { [key: string]: unknown }>(
  arr: T[],
  prop: keyof T,
) => {
  arr.sort((a, b) => {
    if (a[prop] < b[prop]) return -1;
    if (a[prop] > b[prop]) return 1;
    return 0;
  });

  return arr;
};

export const getCaseCaseType = (currentCase: CaseInput) => {
  const { isRepairCase, isComplaintCase, isInsuranceClaimCase, isSalesCase } = currentCase;

  if (isRepairCase) return CaseType.Repair;
  if (isComplaintCase) return CaseType.Complaint;
  if (isInsuranceClaimCase) return CaseType.InsuranceClaim;
  if (isSalesCase) return CaseType.Sales;

  return CaseType.Case;
};

type ToFormatContact = {
  firstName?: string | null;
  lastName?: string | null;
};

export const formatContactDisplayName = (contact: ToFormatContact | null | undefined) => {
  if (!contact || (!contact.firstName && !contact.lastName)) {
    return '-';
  }

  const formattedFirstName = contact.firstName?.trim() || '';
  const formattedLastName = contact.lastName?.trim() || '';
  const seperator = formattedLastName && formattedFirstName ? ' ' : '';

  return `${formattedFirstName}${seperator}${formattedLastName}`;
};

type ReplaceMap = Record<string, string>;

export const mappedReplace = (value: string, replaceMap: ReplaceMap) => {
  const regExp = new RegExp(Object.keys(replaceMap).join('|'), 'g');

  return value.replace(regExp, (match) => replaceMap[match]);
};

export const replaceUrlParams = (route: string, params: ReplaceMap) => {
  const replaceMap: ReplaceMap = {
    ...params,
    // remove delimiter for all react route params
    ':': '',
  };

  return mappedReplace(route, replaceMap);
};

export const containsOnlyDigits = (value: string) => /^\d+$/.test(value);

export const removeSubstrings = (value: string, substrings: string[]) => {
  const substringRegex = new RegExp(substrings.join('|'), 'gi');
  const multiSpaceRegex = /\s+/g;

  const result = value.replace(substringRegex, '');

  return result.replace(multiSpaceRegex, ' ').trim();
};

export const getEnumWithNumberValues = (
  enumObject: Record<string, string | number>,
): { name: string; value: number }[] => {
  const array = Object.entries(enumObject);
  return array
    .filter(([_, value]) => typeof value === 'number')
    .map(([key, value]) => ({ name: key, value: value as number }));
};
